module.exports = __webpack_public_path__ + "static/img/title-banner1-type4.71d4ed2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/6/title-banner1-type4.png
// module id = dK6l
// module chunks = 1